<template>
  <v-layout tag="section">
    <v-flex>
      <v-card>

        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12>
              <p class="font-weight-medium blue--text darken-1 text-xs-center title py-2">
                Be careful of adding a picture because it can be cutted or stretched on FS -
                so add right proportions
              </p>
            </v-flex>
            <v-flex xs12 sm12 lg3 d-flex align-center justify-center>
              <v-flex xs9>
                <content-field
                  label="Search by title"
                  v-model="searchTitle"
                />
              </v-flex>
              <v-flex xs3>
                <v-btn  @click="filterGalleriesByTitle(searchTitle)">Search</v-btn>
              </v-flex>
            </v-flex>
            <v-spacer />
            <!--<v-flex xs12 sm12 md8 lg6 d-flex align-center justify-center>-->
              <!--<v-btn @click="resetCategoryFilter">Reset category filter</v-btn>-->
              <!--<v-btn @click="resetTitleFilter">Reset title filter</v-btn>-->
              <!--<v-btn @click="resetAllFilters">Reset all filters</v-btn>-->
            <!--</v-flex>-->
            <v-flex d-flex align-center justify-center>
              <v-btn @click="resetTitleFilter">Reset title filter</v-btn>
            </v-flex>
            <v-spacer />
            <v-flex xs12 sm12 md3 lg2>
              <v-select
                label="Show items"
                hide-details
                :items="showItems"
                v-model="itemsOnPage"
                @change="changeItemsOnPage($event)"
              />
            </v-flex>
          </v-layout>
        </v-card-actions>

        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex
              xs6 sm4 md3 lg2
              v-for="item in imageList"
              :key="item.id"
            >
              <v-card flat tile class="image">
                <div class="image__dell" @click="deleteItemImage(item.id, item.cloudinaryIds)"></div>
                <v-img
                  :src="createBackgroundUrl(item.imagesUrls.originalImageUrl)"
                  height="180px"
                  @click="handleImageClick(item)"
                >
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-spacer />
            <v-pagination
              :length="+totalPages"
              v-model="page"
              :total-visible="7"
              @input="changeGalleryPage($event)"
            />
          </v-layout>
        </v-container>

      </v-card>
    </v-flex>

    <image-modal v-if="modal" :show="modal" @closeModal = "closeModal" :currentItem="editedItem"/>

  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { pathOr } from 'ramda'

import imageModal from './imageModal'

  export default {
    name: "GalleriesList",
    components: {imageModal},
    data () {
      return {
        page: 1,
        itemsOnPage: 18,
        imageList: [],
        showItems: [12, 18, 36],
        editedItem: {},
        filterCategory: '',
        searchTitle: '',
        modal: false,
        totalPages: 0
      }
    },
    props: {
      modalView: {
        type: Boolean,
        default: false
      },
      pickedImage: {
        type: Function
      }
    },
    methods: {
      ...mapActions([
        'fetchGalleries',
        'deleteImage',
        'deleteStorageImage'
      ]),
      async deleteItemImage (ids, cloudinaryIds) {
        await this.deleteStorageImage(cloudinaryIds[0])
        await this.deleteImage(ids)
        await this.fetchGalleries({
          page: this.page - 1,
          itemsOnPage: this.itemsOnPage,
          category: this.filterCategory,
          title: this.searchTitle
        })
      },
      handleImageClick (item) {
        if (this.pickedImage) {
          this.modalView ? this.pickedImage(item) : this.showModal(item)
        } else {
          this.modalView ? this.$emit('pickedImage', item) : this.showModal(item)  //previus solution
        }
      },
      async deleteItemImage (ids, cloudinaryIds) {
        await this.deleteStorageImage(cloudinaryIds[0])
        await this.deleteImage(ids)
        await this.fetchGalleries({
          page: this.page - 1,
          itemsOnPage: this.itemsOnPage,
          category: this.filterCategory,
          title: this.searchTitle
        })
      },
      showModal (item) {
        this.editedItem = {...item}
        this.modal = true
      },
      closeModal () {
        this.modal = false
        this.editedItem = {}
      },
      fetchGalleriesWithParams({page, itemsOnPage, category, title} = {}){
        let pageToFetch = page ? page : this.page
        this.fetchGalleries({
          page: pageToFetch - 1,
          itemsOnPage: itemsOnPage || this.itemsOnPage,
          category: category || this.filterCategory,
          title: title || this.searchTitle
        })
      },
      resetCategoryFilter(){
        this.filterCategory = ''
        this.fetchGalleriesWithParams()
      },
      resetTitleFilter(){
        this.searchTitle = ''
        this.fetchGalleriesWithParams()
      },
      resetAllFilters(){
        this.filterCategory = ''
        this.resetTitleFilter()
      },
      filterGalleriesByTitle(title){
        this.page = 1
        this.fetchGalleriesWithParams({title})
      },
      changeItemsOnPage(itemsOnPage){
        this.itemsOnPage = itemsOnPage
        this.page = 1
        this.fetchGalleriesWithParams({itemsOnPage})
      },
      changeGalleryPage(page){
        this.page = page
        this.fetchGalleriesWithParams({page})
      },
      createBackgroundUrl (url) {
        const isValidUrl = url.includes('res.cloudinary.com')
        const repl = `$&/q_auto/c_fill,w_200,h_200`
        return isValidUrl ? url.replace(/\/upload/gi, repl) : url
      }
    },
    computed: {
      ...mapGetters(['getGalleries'])
    },
    watch: {
      getGalleries: {
        handler () {
          this.imageList = pathOr([], ['getGalleries', 'list'], this)
          this.totalPages = pathOr([], ['getGalleries', 'totalPages'], this)
        },
        deep: true
      },
    },
    created () {
      this.fetchGalleriesWithParams()
    },
    mounted () {
      this.$bus.$on('getGalleries', ({category} = {})=>{
        if(category) {
          this.filterCategory = category
          this.page = 1
        }
        this.fetchGalleriesWithParams({category})
      })
    },
    beforeDestroy () {
      this.$bus.$off('getGalleries')
    }
  }
</script>

<style lang="scss" scoped>
  .image {
    border-radius: 2px;
    position: relative;

    &__dell {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 1;
      background-color: #fff;
      cursor: pointer;
      width: 20px;
      height: 20px;

      &::before,
      &::after {
        content: "";
        display: block;
        width: 85%;
        height: 2px;
        background-color: #333;
        position: absolute;
        right: 1px;
        top: 9px;
      }

      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Gallery/GalleriesList.vue